<template lang="pug">
    v-card.mx-lg-auto.mt-md-4.mb-md-4(v-if="validProspectPhoneNumber" outlined :width="cardWidth" style="margin: 10px 0px !important;")
        v-toolbar(flat)
            v-btn(
                color="primary"
                icon
                ripple
                @click="showDetails = !showDetails;"
            )
                v-icon(v-if="showDetails === true")
                    | mdi-chevron-down
                v-icon(v-else)
                    | mdi-chevron-right

            v-toolbar-title(style ="font-size: 14px;")
                | {{ prospectPhoneNumber.phone_number | tel }}
        v-divider
        v-card-text(v-if="showDetails === true")
            v-simple-table
                template(v-slot:default)
                    tbody
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Phone Number
                                .cell-value-spacing(v-if="prospectPhoneNumber.phone_number && prospectPhoneNumber.phone_number.length > 0") {{ prospectPhoneNumber.phone_number | tel }}
                                .cell-value-spacing(v-else) N/a
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Phone Number Type
                                .cell-value-spacing(v-if="prospectPhoneNumber.phone_number_type && prospectPhoneNumber.phone_number_type.length > 0") {{ prospectPhoneNumber.phone_number_type | titleize }}
                                .cell-value-spacing(v-else) N/a
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 Do Not Call
                                .cell-value-spacing(v-if="prospectPhoneNumber.do_not_call")
                                    v-icon(color="error") mdi-cellphone-off
                                .cell-value-spacing(v-else) N/a
                        tr
                            td
                                .text-capitalize.text-overline.text--secondary.text--darken-3 US Federal DNC
                                .cell-value-spacing(v-if="prospectPhoneNumber.us_federal_dnc")
                                    v-icon(color="error") mdi-cellphone-off
                                .cell-value-spacing(v-else) N/a

</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        data() {
            return {
                cardWidth: 300,
				showDetails: false,
            }
        },
        methods: {
            handleDetailsResize() {
                const detailsWidth = document?.getElementById('prospect-details-card')?.getBoundingClientRect()?.width
                if (detailsWidth >= 375) {
                    this.cardWidth = detailsWidth - 75
                } else {
                    this.cardWidth = 300
                }
            },
        },
        computed: {
            validProspectPhoneNumber() {
                return this.prospectPhoneNumber?.prospect_phone_number_id > 0;
            },
        },
        props: {
            prospectPhoneNumber: Object,
        },
        watch: {
            prospectPhoneNumber: {
                handler() {
                    Vue.nextTick(() => { this.handleDetailsResize(); });
                },
                deep: true,
            },
        },
        created() {
			window.addEventListener('resize', this.handleDetailsResize);
        },
        destroyed() {
            window.removeEventListener('resize', this.handleDetailsResize);
        },
        mounted() {
            this.handleDetailsResize();
        },
    });
</script>

<style lang="scss" scoped>
    #app {
        .cell-value-spacing {
            padding: 0 0 5px 0;
        }
    }
</style>
